/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/postSubscriptionPreviewOverrides';
import type { PostSubscriptionPreviewRequestBody } from '../../operation-overrides/postSubscriptionPreviewOverrides';

export type PostSubscriptionPreviewQueryParams = NonNullable<
  operations['postSubscriptionPreview']['parameters']['query']
>;
export type { PostSubscriptionPreviewRequestBody };

export interface Input {
  apiVersion?: string;
  query?: PostSubscriptionPreviewQueryParams;
  body: PostSubscriptionPreviewRequestBody;
}

export async function postSubscriptionPreview(
  { apiVersion, body, query }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/billingv2/account/subscription', {
    params: { query },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    body,
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    bodySerializer: overrides.bodySerializer,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
